import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import React from "react";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#A1A1A1 !important"
    },
    contentText: {
      fontSize: "17px",
      fontWeight: 400
    },
    dialogContent: {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    },
    textField: {
      marginTop: "20px",
      width: "100%"
    }
  },
  {
    name: "StoreOrderOverrideDialog"
  }
);

interface GrabExpressConfirmationDialogProps extends DialogProps {
  onConfirm?: () => void;
  onCancel?: string;
}

const GrabExpressConfirmationDialog: React.FC<GrabExpressConfirmationDialogProps> = props => {
  const { onClose, open, onConfirm } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      onClose={() => {
        onClose();
      }}
      open={open}
      maxWidth="xs"
      fullWidth
    >
      <>
        <DialogTitle>Update Override Status</DialogTitle>
        <DialogContent>
          <div className={classes.dialogContent}></div>
          <span className={classes.contentText}>
            Are you sure you want to update the status of this order before
            updating the grab status?
          </span>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              id="dialogActionCancelBtn"
              autoFocus
              onClick={() => {
                onClose();
              }}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              id="dialogActionConfirmBtn"
              autoFocus
              //   disabled={reason ? false : true}
              onClick={() => {
                onConfirm();
              }}
              color="primary"
              variant="contained"
            >
              Yes
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default GrabExpressConfirmationDialog;
